import {
  CREATE_PRESCRIPTION_PATIENT_LIST_RECEIVED,
  PATIENT_LIST_RECEIVED,
  PATIENT_NOTE_RECEIVED,
  PENDING_PATIENT_RECEIVED,
  SELECTED_PATIENT_NAME_ADDED,
} from "../constants/types/patientType";
import { parseData } from "../utils/helper";

const initialState = {
  pendingPatientList: [],
  patientList: [],
  createPrescriptionPatientList: [],
  activePatientNotes: [],
  selectedPatientName: "",
};

export const patientReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_PATIENT_NAME_ADDED: {
      return {
        ...state,
        selectedPatientName: action.payload,
      };
    }
    case PENDING_PATIENT_RECEIVED: {
      return {
        ...state,
        pendingPatientList: action.payload,
      };
    }
    case PATIENT_LIST_RECEIVED: {
      return {
        ...state,
        patientList: action.payload,
      };
    }
    case PATIENT_NOTE_RECEIVED: {
      return { ...state, activePatientNotes: action.payload };
    }
    case CREATE_PRESCRIPTION_PATIENT_LIST_RECEIVED: {
      return {
        ...state,
        createPrescriptionPatientList: action?.payload,
        // createPrescriptionPatientList: action?.payload.map((item, index) => ({
        //   ...item,
        //   uniqueId: index,
        // })),
      };
    }
    default:
      return state;
  }
};
